import { Card, CardContent, Grid } from '@mui/material';
import { Login } from 'src/lib/itaptec/components_login/src'
import { AuthorizationRequest, ItecError } from 'src/lib/itaptec/http_client/src';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLoader } from 'src/hooks/useLoader';
import { apiAuth, refreshToken } from 'src/http/api';
import { HttpAxiosRequest } from 'src/http/httpAxiosBase';
import { AuthorizationResponse, AuthorizationResponseFields } from 'src/types/user/authData';
import { userStorage } from 'src/utils/localStorage';
import {useAction} from "../../hooks/useAction";

const LoginPage = () => {
    const { reloadProfile } = useAction();
    const { showLoader, hideLoader } = useLoader();
    const navigate = useNavigate();
    const location = useLocation();

    function onLoginResponse(response: AuthorizationResponse) {
        refreshToken(response[AuthorizationResponseFields.AccessToken]);
        HttpAxiosRequest.refreshToken(response[AuthorizationResponseFields.AccessToken]);
        reloadProfile();

        const groupsIds: number[] = response[AuthorizationResponseFields.GroupIds].split(",").map((x: string) => parseInt(x));
        const profilesIds: number[] = response[AuthorizationResponseFields.ProfileIds].split(",").map((x: string) => parseInt(x));

        userStorage.save(
            response[AuthorizationResponseFields.UserId],
            response[AuthorizationResponseFields.Mail],
            groupsIds,
            profilesIds,
            response[AuthorizationResponseFields.PersonRoleId],
            response[AuthorizationResponseFields.PasswordChangeDaysRemaining],
            response[AuthorizationResponseFields.Lastname],
            response[AuthorizationResponseFields.DefaultLanguage],
            response[AuthorizationResponseFields.IsBankGroup],
            response[AuthorizationResponseFields.IsInternalGroup],
            response[AuthorizationResponseFields.AccessToken],
            response[AuthorizationResponseFields.IsAdmin],
            response[AuthorizationResponseFields.CodCargo],
            response[AuthorizationResponseFields.Cargo],
            response[AuthorizationResponseFields.CanCreateNewMessage]
        );

        navigate(location.state?.from || '/home')
    }

    function onLogIn(data: AuthorizationRequest) {
        showLoader()
        apiAuth.auth<AuthorizationRequest>({ ...data, ipClient: "" })
            .then(onLoginResponse)
            .catch((err: ItecError) => toast.error(err.message))
            .finally(hideLoader)
    }

    function onGoogleLogin({ code }: { code: string }) {
        showLoader()
        apiAuth.authGoogle({ token: code })
            .then(onLoginResponse)
            .catch((err: ItecError) => toast.error(err.message))
            .finally(hideLoader)
    }

    return (
        <Grid container justifyContent={'center'} alignItems={'center'} sx={{ height: '100vh !important' }}>
            <Card sx={{ zIndex: 1 }}>
                <CardContent sx={{
                    p: theme => `${theme.spacing(12, 9, 12)} !important`
                }}>
                    <Login
                        loginOptions={{
                            google: window.LOGIN_GOOGLE || false,
                            internal: window.LOGIN_ITAPTEC || false
                        }}
                        onValid={onLogIn}
                        onGoogleLogin={onGoogleLogin}
                        logo='/images/logo-puente.svg'
                        overrideProps={{
                            buttonProps: {
                                variant: 'contained'
                            }
                        }}
                    />
                </CardContent>
            </Card>
        </Grid>
    )
}

export default LoginPage
